var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#3256B8",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2968 15.5383C16.3777 17.3704 14.8991 18.9196 12.9946 18.9975C12.8543 19.0034 6.01525 18.9896 6.01525 18.9896C4.1199 19.1335 2.46109 17.7715 2.31159 15.9463C2.30033 15.8103 2.3034 8.47219 2.3034 8.47219C2.21943 6.63815 3.69598 5.08499 5.60157 5.00418C5.7439 4.99728 12.5737 5.01009 12.5737 5.01009C14.4783 4.86818 16.1422 6.24001 16.2897 8.07405C16.2999 8.2061 16.2968 15.5383 16.2968 15.5383Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3 9.97984L19.593 7.28484C20.409 6.61684 21.633 7.19884 21.632 8.25184L21.62 15.6008C21.619 16.6538 20.394 17.2308 19.58 16.5628L16.3 13.8678",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg12);
export default __webpack_public_path__ + "static/media/12.e085269d7962ca5a8b2935885bf25e02.svg";
export { ForwardRef as ReactComponent };